import {
    TooltipPlacement,
} from '../Tooltip'

export enum TypeIcon {
    INFO = 'info',
    WARNING = 'warning',
}

export type NotificationIconProps = {
    type: TypeIcon,
    content?: string | (() => JSX.Element) | JSX.Element,
    tooltipPlacement?:TooltipPlacement
}
